export enum ColorFamilyFocusRegion {
  FamilySwitcher = 'family-switcher',
  familyDescription = 'family-description',
}
